import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

declare interface RouteInfo {
  text: string
  text2: string
  text3: string
}

export const PolicyEngagementAndResourcesContent: RouteInfo[] = [
  {
    text:
      'Influencing policy is a necessary means to achieve change and a favorable economic environment.  For over forty years, the California Hispanic Chambers of Commerce has fostered sustainable policy change at the state and national levels.',
    text2:
      'Policy change can take many forms: while changes to legislation are often seen as the most concrete ways of making change happen, public policy comprises many non-legislative issues, such as regulations, resource allocation, and decisions about whose voices to include in debates or what evidence to base decisions on.',
    text3:
      'The CHCC provides numerous engagement tools and resources to improve your policy engagement and your capacity to influence change.  It comprises a suite of tools and research references that any chamber can use at any stage in its policy engagement process.  These tools will assist in identifying the problem and understanding the impact your advocacy work could have on policy-making.  Assist you in setting realistic objectives for policy influence, develop a plan to achieve those objectives, monitor and learn from the progress you are making and reflect this learning into your advocacy work.',
  },
]

@Component({
    selector: 'app-policy-engagement-and-resources',
    templateUrl: './policy-engagement-and-resources.component.html',
    styleUrls: ['./policy-engagement-and-resources.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PolicyEngagementAndResourcesComponent implements OnInit {
  mainTitle = 'Policy Engagement and Resources'
  texts: any = []
  constructor() {}

  ngOnInit(): void {
    this.texts = PolicyEngagementAndResourcesContent.filter((text) => text)
  }
}
